<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.spfr" alt style="white-space:normal;">
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:14pt;font-family:Arial;">Level Rewinding Machine</span>
        </b>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:10pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:10pt;font-family:Arial;">
          This unit is used for scattered refined copper tube
          after spinning, through the process such as straighten, clean, dry, detect (print),
          pre-flex, split without crumbs, and roll them densely and orderly into a cable
          shape plate, as the finished product delivery or further annealing. This unit
          had been sold to Ukraine etc.
        </span>
        <span style="font-size:10.0pt;font-family:&quot;color:black;"></span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p></p>
      <table
        style="border-collapse:collapse;border:none;"
        border="1"
        cellpadding="0"
        cellspacing="0"
      >
        <tbody>
          <tr>
            <td colspan="5" style="border:solid windowtext 1.0pt;" valign="top" width="568">
              <p style="text-align:center;" align="center">
                <span style="font-size:14pt;font-family:Arial;">
                  Technical
                  parameters
                </span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">No.</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="196">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  Model
                  &amp; Data
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Unit</span>
              </p>
            </td>
            <td colspan="2" style="border:solid windowtext 1.0pt;" valign="top" width="227">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Range</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">1</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="196">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  O.D.of
                  tube
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">mm</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ4-19</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ1.5-8</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">2</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="196">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  Max.
                  wall thickness
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">mm</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">1.2</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">1.0</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">3</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="196">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  Max.
                  coil weight
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">kg</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">300</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">150</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">4</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="196">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  Coiling
                  speed
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">m/min</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">0-300</span>
              </p>
              <p>
                <span style="font-size:10pt;font-family:Arial;">0-500</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">0-120</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">5</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="196">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  Max.
                  O.D.of coil
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">mm</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ1230</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ700</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">6</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="196">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  Coil
                  width
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">mm</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">120-400</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">50-200</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">7</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="196">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  I.D.of
                  coil
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">mm</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ610</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ300</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">8</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="196">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  Total
                  installed power
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">kw</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  75,
                  90
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">22</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">9</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="196">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  Pressure
                  of hydraulic system
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Kg/cm2</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">63</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">40</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">10</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="196">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  Flow
                  quantity of hydraulic system
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">L/min</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">34</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">24</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">11</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="196">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  Pressure
                  of compressed air
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Kg/cm2</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">4-7</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">4</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">12</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="196">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  Total
                  length of machine
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">m</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">11.5</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">7.7</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">13</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="196">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  Height
                  of machine center line
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">m</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">1.5</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="114">
              <p>
                <span style="font-size:10pt;font-family:Arial;">1.2</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p></p>
      <p>
        <span style="font-size:10.0pt;font-family:&quot;">
          <br>
        </span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        spfr: require("../../../assets/img/common/spfr.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/device/spfr.vue